export default "__VITE_ASSET__DuIw_18d__"